import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AccessTime, CancelOutlined } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert.jsx";
import { NotificationManager } from "react-notifications";

class ProviderInfoScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            showAlertAccept: false,
            showAlertReject: false,
            bookingDetails: this.props.history.location.state.bookingDetails,
            provider_id: this.props.history.location.state.bookingDetails.provider_id,
            provider_details: null
            // bookingListHeadingPrev: this.props.history.location.state.heading
        };
    }
    componentDidMount() {
        console.log("pro info DETAILS", this.state.bookingDetails);
        this.getProviderData();
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: '100%', margin: 10, }} key={index}>
                <ContentLoader
                    height={250}
                    width={600}
                    speed={2}
                    borderRadius={10}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ddd"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="97%" height="250" borderRadius="10px" />
                </ContentLoader>
            </div>
        );
    };

    getProviderData = async() => {
        var authToken = getCookies();
        try {
          const {data} = await Axios({
            method: 'get', 
            url: `${SERVER_URL}/profile/user-details?provider_id=${this.state.provider_id}`,
            headers: {
              'x-auth-Token': authToken,
            },
          });
          console.log('pro info DATA', data);
          if (data.status == 'OK') {
            this.setState({
              loading:false,
              provider_details: data.data
            })
          }
          else{
            this.setState({
              loading:false
            })
          }
        } catch (error) {
          console.log("====================pro info ERRORRRRRR",error);
        }
    }

    render() {
        console.log("provider_details", this.state.provider_details);
        var card={
            display: 'flex',
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 20,
            padding: 20,
            width: '100%'
        }
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Provider Details' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            {
                                    this.state.loading 
                                    ? this.renderLoading()
                                    :
                                            <div style={card}>
                                                <div style={{
                                                    width: '40%'
                                                }}>
                                                    <img src={this.state.provider_details.proImage.small} 
                                                    style={{height: '20rem', width: '20rem', borderRadius: 10}} />
                                                </div>
                                                <div style={{
                                                    width: '60%'
                                                }}>
                                                    <p>{this.state.provider_details.name}</p>
                                                    <p>{this.state.provider_details.businessName}</p>
                                                    <p>Address - </p>
                                                    <p style={{
                                                        border: '1px solid #eee',
                                                        padding: 15,
                                                        margin: '5px 0',
                                                        borderRadius: 5
                                                    }}>
                                                        {this.state.provider_details.addresses[0].address_line1}
                                                    </p>
                                                    <p>Mobile - +1 {this.state.provider_details.phone}</p>
                                                    <p>Email - {this.state.provider_details.email}</p>
                
                                                </div>
                                            </div>
                            }
                            <div style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginTop: 20
                                }}>
                                <p 
                                    onClick={()=> this.props.history.goBack(null)}
                                style={{
                                    backgroundColor: '#0078ff',
                                    padding: 10,
                                    color: '#fff',
                                    borderRadius: 5,
                                    fontSize: 16,
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>Okay <ArrowForward /></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(ProviderInfoScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ProviderInfoScreenNew.jsx